import swal from 'sweetalert2';

const confirmButtonColor = '#e50695';
const cancelButtonColor = '#343a40';
const denyButtonColor = '#8a2be2';

const Toast = swal.mixin({
    toast: true,
    position: 'top',
    showConfirmButton: false,
    timer: 3000,
    timerProgressBar: true,
    didOpen: (toast) => {
        toast.addEventListener('mouseenter', swal.stopTimer);
        toast.addEventListener('mouseleave', swal.resumeTimer);
    },
});

const Alert = swal.mixin({
    showConfirmButton: true,
    allowOutsideClick: false,
    allowEscapeKey: false,
    confirmButtonColor,
});

const ConfirmationWindow = swal.mixin({
    showCancelButton: true,
    confirmButtonText: 'Yes',
    confirmButtonColor,
    cancelButtonColor,
    denyButtonColor,
});

window.showConfirmation = (
    title,
    message = null,
    confirmButtonText = 'OK',
    cancelButtonText = 'Cancel',
    icon,
    fnOk = null,
    fnCancel = null,
    footer = null,
    width = 'auto',
) => {
    ConfirmationWindow.fire({
        icon,
        title,
        html: message,
        confirmButtonText,
        cancelButtonText,
        footer,
        width,
    }).then((res) => {
        if (res.isConfirmed && typeof fnOk === 'function') {
            fnOk();
        } else if (res.isDismissed && typeof fnCancel === 'function') {
            fnCancel();
        }
    });
};

window.showConfirmationThreeOptions = (
    title,
    message = null,
    confirmButtonText = 'Yes',
    denyButtonText = 'Deny',
    cancelButtonText = 'Cancel',
    approvedFn = null,
    deniedFn = null,
    cancelFn = null,
) => {
    ConfirmationWindow.fire({
        icon: 'info',
        title,
        html: message,
        showDenyButton: true,
        cancelButtonText,
        confirmButtonText,
        denyButtonText,
        confirmButtonColor,
        cancelButtonColor,
        denyButtonColor,
    }).then((res) => {
        if (res.isConfirmed && typeof approvedFn === 'function') {
            approvedFn();
        }
        if (res.isDenied && typeof deniedFn === 'function') {
            deniedFn();
        }
        if (res.isDismissed && typeof cancelFn === 'function') {
            cancelFn();
        }
    });
};

window.showSuccess = (title, message = null, fn = null) => {
    Alert.fire({
        icon: 'success',
        title,
        html: message,
    }).then((res) => {
        if (res.isConfirmed && typeof fn === 'function') {
            fn();
        }
    });
};

window.showError = (title, message = null, fn = null) => {
    Alert.fire({
        icon: 'warning',
        title,
        html: message,
    }).then((res) => {
        if (res.isConfirmed && typeof fn === 'function') {
            fn();
        }
    });
};

window.show422Errors = (error) => {
    if (error.response.status === 422 && error.response.data.errors) {
        let output = '';
        Object.entries(error.response.data.errors).forEach((item) => {
            const [field, message] = item;
            output += `${message}<br>`;
        });
        window.showError('', output);
    }
};

window.showToastSuccess = (title, fn = null) => {
    Toast.fire({
        icon: 'success',
        title,
    }).then(() => {
        if (typeof fn === 'function') {
            fn();
        }
    });
};

window.showToastError = (title) => {
    Toast.fire({
        icon: 'warning',
        title,
    });
};
